export default __webpack_public_path__ + "static/media/imagen-left.d878d842.jpg";